import { PageCriteriaDTO } from '@dto/PageCriteriaDTO';
import { DoctorStatus } from '@enum/doctor/DoctorStatus';

export class DoctorPageCriteriaDTO extends PageCriteriaDTO {
  public status: DoctorStatus;
}